import {
  flexRender,
} from "@tanstack/react-table";

export default function TableHeader({ table, styles, headerRowStyle, headerTextStyle, innerCellStyle, allowColumnHeaderSort }) {
  if (styles) {
    if (!headerRowStyle) headerRowStyle = styles.headerRow;
    if (!headerTextStyle) headerTextStyle = styles.headerText;
    if (!innerCellStyle) innerCellStyle = styles.innerCell;
  }
  return (
    <>
      {table.getHeaderGroups().map(headerGroup => {
        return (
          <div key={headerGroup.id} className={headerRowStyle}>
            {headerGroup.headers.map(header => {
              return (
                <div key={header.id} className={`${headerTextStyle} ${header.column.columnDef.className ?? ''}`} >
                  {header.isPlaceholder ? null : (
                    <div className={`${innerCellStyle ?? ''} ${header.column.getCanSort() && allowColumnHeaderSort ? styles.cursorPointer : ''}`}
                      onClick={allowColumnHeaderSort ? header.column.getToggleSortingHandler() : undefined}
                      >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {
                        {
                          asc: '\u00A0🔼',
                          desc: '\u00A0🔽',
                        }[header.column.getIsSorted() || null]
                      }
                      {header.column.getCanFilter() ? (
                        <div>
                          {/*<Filter column={header.column} table={table} />*/}
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              )
            })}
          </div>)
      })
      }
    </>
  )
}